import { Box, Text } from '@mantine/core';

type Variant = 'active' | 'available' | 'trial' | 'beta' | 'none';

// Every variant reads from theme tokens (global.css defines both schemes) — fixed brand hexes
// were light-surface colours and faded on dark-mode surfaces.
const STYLES: Record<Variant, { background: string; border: string; color: string; label: string }> = {
  active: {
    background: 'var(--brand-soft)',
    border: 'var(--brand-soft-bd)',
    color: 'var(--status-success)',
    label: 'Active',
  },
  available: {
    background: 'var(--badge-available-bg)',
    border: 'var(--badge-available-bd)',
    color: 'var(--badge-available)',
    label: 'Available',
  },
  trial: {
    background: 'var(--badge-available-bg)',
    border: 'var(--badge-available-bd)',
    color: 'var(--badge-available)',
    label: 'Trial',
  },
  beta: {
    background: 'var(--badge-beta-bg)',
    border: 'var(--badge-beta-bd)',
    color: 'var(--badge-beta)',
    label: 'Beta',
  },
  none: {
    background: 'var(--bg-subtle)',
    border: 'var(--border-default)',
    color: 'var(--text-subtle)',
    label: 'Not available',
  },
};

export function StatusBadge({ variant, label }: Readonly<{ variant: Variant; label?: string }>) {
  const s = STYLES[variant];
  return (
    <Box
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '3px 10px',
        borderRadius: 999,
        background: s.background,
        border: `1px solid ${s.border}`,
        color: s.color,
        fontSize: 11,
        fontWeight: 400,
        letterSpacing: 0.4,
        textTransform: 'uppercase',
      }}
    >
      <Text component="span" inherit>{label ?? s.label}</Text>
    </Box>
  );
}
